export function initCopyButtons() {
  document.querySelectorAll("[data-copy-value]").forEach((button) => {
    if (button.dataset.copyReady) return
    button.dataset.copyReady = "true"
    button.addEventListener("click", async () => {
      const previous = button.textContent
      try {
        await navigator.clipboard.writeText(button.dataset.copyValue)
        button.textContent = "¡Copiado!"
      } catch (_) {
        window.prompt("Copiá este link", button.dataset.copyValue)
      }
      window.setTimeout(() => { button.textContent = previous }, 1800)
    })
  })
}
